module.exports = __webpack_public_path__ + "static/img/radio_s.59f2959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/radio_s.png
// module id = HhaX
// module chunks = 21